"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableStatusMessage = exports.TableStatus = void 0;
var _react = _interopRequireDefault(require("react"));
var _LoadingIndicator = require("../LoadingIndicator");
var _Icons = require("../Icons");
var _classnames = _interopRequireDefault(require("classnames"));
var _MessageModule = _interopRequireDefault(require("./Message.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/*************************
 * TableMessage
 ************************/

var TableMessage = _ref => {
  var className = _ref.className,
    children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_MessageModule.default.Container, className)
  }, children);
};

/*************************
 * Table Status Message
 ************************/
var TableStatus = exports.TableStatus = /*#__PURE__*/function (TableStatus) {
  TableStatus["LOADING"] = "loading";
  TableStatus["EMPTY"] = "empty";
  TableStatus["SEARCHING"] = "searching";
  TableStatus["ERROR"] = "error";
  return TableStatus;
}({});
var StatusMessage = {
  [TableStatus.LOADING]: 'Loading',
  [TableStatus.EMPTY]: 'Nothing to see here.',
  [TableStatus.SEARCHING]: 'Searching',
  [TableStatus.ERROR]: 'Something went wrong!'
};
var StatusIcon = {
  [TableStatus.LOADING]: /*#__PURE__*/_react.default.createElement(_LoadingIndicator.Spinner, null),
  [TableStatus.EMPTY]: /*#__PURE__*/_react.default.createElement(_Icons.IconFolderClosed, null),
  [TableStatus.SEARCHING]: /*#__PURE__*/_react.default.createElement(_LoadingIndicator.Spinner, null),
  [TableStatus.ERROR]: /*#__PURE__*/_react.default.createElement(_Icons.IconAlertCircle, null)
};
var TableStatusMessage = _ref2 => {
  var className = _ref2.className,
    status = _ref2.status,
    message = _ref2.message;
  return /*#__PURE__*/_react.default.createElement(TableMessage, {
    className: className
  }, StatusIcon[status], " ", message !== null && message !== void 0 ? message : StatusMessage[status]);
};
exports.TableStatusMessage = TableStatusMessage;
//# sourceMappingURL=Message.js.map